export default __webpack_public_path__ + "static/media/7.2a636ede.jpg";